module.exports = __webpack_public_path__ + "odinstatic/v5.0.2/media/operator.6dad6524.svg";